import React from "react";
import PropTypes from "prop-types";
import { Box, Button, Typography } from "@material-ui/core";

import ConfirmDialog from "../../components/ConfirmDialog";
import { useToolStyles } from "./styles";

/** Confirm/cancel dialog for a tool action that writes to the database. */
const ConfirmAction = ({
  open,
  title,
  text,
  confirmLabel,
  busy,
  onConfirm,
  onCancel,
}) => {
  const classes = useToolStyles();
  return (
    <ConfirmDialog
      open={open}
      handleClose={onCancel}
      title={title}
      disableBackdropClose
    >
      <Box>
        <Typography className={classes.dialogText}>{text}</Typography>
        <Box className={classes.dialogActions}>
          <Button className={classes.touch} onClick={onCancel} disabled={busy}>
            Cancel
          </Button>
          <Button
            className={classes.touch}
            variant="contained"
            color="primary"
            onClick={onConfirm}
            disabled={busy}
          >
            {confirmLabel}
          </Button>
        </Box>
      </Box>
    </ConfirmDialog>
  );
};

ConfirmAction.propTypes = {
  open: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  confirmLabel: PropTypes.string.isRequired,
  busy: PropTypes.bool,
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};

ConfirmAction.defaultProps = { busy: false };

export default ConfirmAction;
